import axios from 'axios';
// const baseURL = baseUrl()
const baseURL = process.env.REACT_APP_URL
axios.defaults.baseURL = baseURL

const updateKey = () => {
    let user = undefined
    try {
        user = JSON.parse(localStorage.getItem("auth") || '{}')
        // console.log("auth session", user)
    } catch (err) { }
    if (user?.token) {
        // console.log("token applied", user)
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.token
        // console.log("header", axios.defaults.headers.common['Authorization'])
    } else {
        axios.defaults.headers.common['Authorization'] = null
    }
}
const handleError = (error) => {
    console.log("message", error)
    if (error?.message == "Network Error") {
        error = { response: { data: "", status: 404 } }
        error.response.data = "Network lost please check your internet connection"
    } else if (error?.response?.status == 403) {
        return { status: error.response.status, error: true, message: error?.response?.data?.message || error?.response?.data?.detail }
    } else if (error?.response?.status == 401) {
        const errorMsg = error?.response?.data?.detail || error?.response?.data?.message || "Your session has ended because this account was logged in from another device or browser.";
        try {
            localStorage.removeItem("auth");
            axios.defaults.headers.common['Authorization'] = null;
            window.dispatchEvent(new CustomEvent('session_terminated', { detail: { message: errorMsg } }));
        } catch (e) {}
        return { status: 401, error: true, message: errorMsg };
    }
    let message = error?.response?.data;
    if (typeof message === 'object' && message !== null) {
        message = message.detail || message.message || message.error || (message.non_field_errors && message.non_field_errors[0]);
    } else if (typeof message === 'string' && (message.trim().startsWith('<') || (error?.response?.status && error.response.status >= 500))) {
        message = "Server error occurred. Please contact administrator or try again later.";
    }
    return { status: error?.response?.status, error: true, message: message || "An unexpected error occurred." }
}

const handleAuth = (data) => {
    if (data?.code == 401 || data?.status == 401) {
        try {
            localStorage.removeItem("auth");
            axios.defaults.headers.common['Authorization'] = null;
            window.dispatchEvent(new CustomEvent('session_terminated', { detail: { message: data?.message || data?.detail || "Session expired." } }));
        } catch (e) {}
        console.log("********************* Auth ", data)
        return data
    }
    if (data?.code == 403) {
        localStorage.setItem("auth", null)
        axios.defaults.headers.common['Authorization'] = null
        return data
    }
}

export const getRequest = async (url) => {

    updateKey()

    try {
        const todos = await axios.get(url)
        handleAuth(todos.data)
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}

// Create New Todo
export const postRequest = async (url, data) => {
    updateKey()
    if (url == "token/") {
        axios.defaults.headers.common["Authorization"] = null;
    }
    // axios.defaults.headers.common["content-type"] = 'multipart/form-data'
    console.log("post called", url)
    try {
        const todos = await axios.post(url, data)
        console.log("API todos..", todos?.data)
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}
export const putRequest = async (url, data) => {
    console.log("put called", url)
    updateKey()
    try {
        const todos = await axios.put(url, data);
        todos.data.data.message = todos.data.message
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}
//patch
export const patchRequest = async (url, data) => {
    updateKey()
    console.log("patch called", url)
    try {
        const todos = await axios.patch(url, data);
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}


// Delete existed todo
export const delRequest = async (url, id) => {
    updateKey()
    console.log(url, id)
    url = `${url}${id}/`
    try {
        const todos = await axios.delete(url);
        return { ...todos.data, message: todos.data.message }
        //let data = await axios.delete(url)
        // console.log("DEL DATA", data);
        //return id
    } catch (err) {
        return handleError(err)
    }
}

